export default __webpack_public_path__ + "static/media/landing-page-img.5fc21bd3.webp";